import { IPageParams } from '@/types/service';
import { get, post, put, remove } from '@/utils/request';

export const getAgreementsPage = async ({ current, pageSize }: IPageParams) => {
  return await get(`/api/agreements/page`, {
    params: {
      current,
      pageSize,
    },
  });
};

export const createAgreements = async (data: any) => {
  return await post(`/api/agreements`, { data });
};

export const updateAgreements = async (data: any) => {
  return await put(`/api/agreements`, { data });
};

export const getAgreementsList = async () => {
  return await get(`/api/agreements/list`);
};

export const getAgreementsEnable = async () => {
  return await get(`/api/agreements/enable`);
};

export const removeAgreements = async (id: number) => {
  return await remove(`/api/agreements/${id}`);
};
